module.exports = __webpack_public_path__ + "static/struff-profile-10b4c3d46c490a73813d368c145abb0e.jpg";